var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotorL({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg7024",
    viewBox: "2135.306 6140.141 153.634 153.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 38.537,
    height: 21.907,
    x: 2168.891,
    y: 6138.587,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 38.537,
    height: 77.177,
    x: 2146.053,
    y: 6207.134,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 27.029,
    height: 28.403,
    x: 2157.349,
    y: 6198.806,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 60.229,
    height: 65.29,
    x: 2156.6,
    y: 6150.155,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 48.66,
    height: 54.444,
    x: 2162.384,
    y: 6155.217,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    width: 40.129,
    height: 40.129,
    x: 2132.306,
    y: 6256.646,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M0 136.571a17.07 17.07 0 0 1 14.122-16.812l-.365-.388-.01-35.771c0-.419.142-.4.392-.673L25.043 72.4V62.372l-.75-.775V60.8H17.5a4 4 0 0 1-4-4V30.978a4 4 0 0 1 4-4h6.793V18.8a5.784 5.784 0 0 1 5.784-5.784h6.508v-7.57A4 4 0 0 1 39.477 1.6v-1a.607.607 0 0 1 .607-.6h26.262a.607.607 0 0 1 .607.607v1.282a4 4 0 0 1 2.169 3.557v7.569h3.615a5.784 5.784 0 0 1 5.784 5.785v29.64C68.153 62.5 60.394 72.305 60.394 72.305H59.8s-7.092-.053-13.682-.1l.034 11.8h6.882a4 4 0 0 1 4 4v25.826a4 4 0 0 1-4 4h-6.785l.034 11.775c0 .838-.155.838-.462 1.137l-10.415 10.099-.212.191a1.518 1.518 0 0 1-1.594-.233A17.067 17.067 0 0 1 0 136.571Z",
    className: "cls-1",
    "data-name": "Union 6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M5.784 0h42.66a5.784 5.784 0 0 1 5.784 5.784v29.64C43.86 49.487 36.1 59.29 36.1 59.29h-.595s-19.462-.147-23.864-.147a2.28 2.28 0 0 1-2.378-.985L0 48.582V5.784A5.784 5.784 0 0 1 5.784 0Z",
    className: "cls-1",
    "data-name": "Path 9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M5.784 0h31.091a5.784 5.784 0 0 1 5.785 5.784v22.248C34.013 39.3 27.1 48.444 27.1 48.444H5.784A5.784 5.784 0 0 1 0 42.66V5.784A5.784 5.784 0 0 1 5.784 0Z",
    className: "cls-1",
    "data-name": "Path 10"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Large Motor"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Mask Group 6",
    transform: "rotate(-152.055 1889.72 2881.126) scale(1.15422)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Large motor",
    transform: "translate(-1.623)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M47.584 84.012h5.612a5.461 5.461 0 0 1 5.461 5.461v22.9a5.461 5.461 0 0 1-5.461 5.461h-5.612a5.461 5.461 0 0 1-5.461-5.457V89.473a5.461 5.461 0 0 1 5.461-5.461Z",
    className: "cls-1",
    "data-name": "Path 45"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.792,
    cy: 3.792,
    r: 3.792,
    fill: "#fff",
    className: "cls-3",
    "data-name": "Ellipse 2",
    transform: "translate(49.555 85.528)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.792,
    cy: 3.792,
    r: 3.792,
    fill: "#fff",
    className: "cls-3",
    "data-name": "Ellipse 1",
    transform: "translate(49.555 108.736)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M41.707 0h26.262a.607.607 0 0 1 .607.607V5.9a.607.607 0 0 1-.607.607H41.707A.607.607 0 0 1 41.1 5.9V.607A.607.607 0 0 1 41.707 0Z",
    className: "cls-1",
    "data-name": "Path 36"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)",
    transform: "translate(-2133.68 -6140.14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M2172.497 6141.59h31.323a.607.607 0 0 1 .607.607v14.693a.607.607 0 0 1-.607.607h-31.323a.607.607 0 0 1-.607-.607v-14.693a.607.607 0 0 1 .607-.607Z",
    className: "cls-1",
    "data-name": "Path 34"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.265 93.933a4.151 4.151 0 0 1-2.342.705 5.131 5.131 0 0 1-2.988-.705c-1.257-.931-1.229.1-1.229.1v1.8c0 .45.553.846 1.229.459.676-.387 1-.581 1-.581s.361-.184.361.335v2.62s.021.786-.73.768c-.751-.018-1.38 0-1.38 0s-.293.248-.293 1.385.293 1.322.293 1.322h1.38s.73-.024.73.649v1.3s.227.359 1.169.306a3.6 3.6 0 0 0 1.4-.306v-1.3a.67.67 0 0 1 .66-.649c.631-.01 1.257 0 1.257 0s.252-.191.287-1.322c.035-1.131-.287-1.385-.287-1.385h-1.257s-.805-.052-.817-.768c-.012-.716 0-2.62 0-2.62s-.047-.515.332-.335 1.215.581 1.215.581.83.407.814-.459c-.016-.866 0-1.8 0-1.8s-.072-.534-.804-.1z",
    className: "cls-3",
    "data-name": "Path 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.415 105.732a.83.83 0 0 1 1.2-.594 6.516 6.516 0 0 0 2.85.772 5.05 5.05 0 0 0 2.768-.772c.829-.4 1.067.594 1.067.594v1.76a.71.71 0 0 1-1.067.561 5.791 5.791 0 0 0-2.768-.837 7.06 7.06 0 0 0-2.85.837s-1.178.239-1.2-.561c-.022-.8 0-1.76 0-1.76z",
    className: "cls-3",
    "data-name": "Path 3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)",
    transform: "translate(-2133.68 -6140.14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "m2149.446 6223.063 13.404-12.929 18.571.67.171 58.946c0 .838-.155.838-.462 1.137l-10.416 10.096-.212.19c-.584.4-1.987-.115-1.987-.952l-19.449-20.71-.011-35.774c0-.419.142-.402.391-.674z",
    className: "cls-1",
    "data-name": "Path 1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)",
    transform: "translate(-2133.68 -6140.14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M2160.347 6201.805v17.253s.019.845.3 1.121c.281.276 3.516 3.626 3.516 3.626a1.566 1.566 0 0 0 1.157.4c.758-.025 11.627 0 11.627 0l4.429-4.7v-7.963l-10.662-.567z",
    className: "cls-1",
    "data-name": "Path 2"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4",
    transform: "translate(15.123 26.978)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M5.461 0h5.612a5.461 5.461 0 0 1 5.461 5.461v22.9a5.461 5.461 0 0 1-5.461 5.461H5.461A5.461 5.461 0 0 1 0 28.365V5.461A5.461 5.461 0 0 1 5.461 0Z",
    className: "cls-1",
    "data-name": "Path 44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.792,
    cy: 3.792,
    r: 3.792,
    fill: "#fff",
    className: "cls-3",
    "data-name": "Ellipse 3",
    transform: "translate(1.062 1.517)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.792,
    cy: 3.792,
    r: 3.792,
    fill: "#fff",
    className: "cls-3",
    "data-name": "Ellipse 4",
    transform: "translate(1.062 24.725)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.772 9.922a4.151 4.151 0 0 1-2.342.705 5.131 5.131 0 0 1-2.988-.705c-1.257-.931-1.229.1-1.229.1v1.8c0 .45.553.846 1.229.459.676-.387 1-.581 1-.581s.361-.184.361.335v2.62s.021.786-.73.768c-.751-.018-1.38 0-1.38 0s-.293.248-.293 1.385.293 1.322.293 1.322h1.38s.73-.024.73.649v1.3s.227.359 1.169.306a3.6 3.6 0 0 0 1.4-.306v-1.3a.67.67 0 0 1 .66-.649c.631-.01 1.257 0 1.257 0s.252-.191.287-1.322c.035-1.131-.287-1.385-.287-1.385H7.032s-.805-.052-.817-.768c-.012-.716 0-2.62 0-2.62s-.047-.515.332-.335 1.215.581 1.215.581.83.407.814-.459c-.016-.866 0-1.8 0-1.8s-.072-.534-.804-.1z",
    className: "cls-3",
    "data-name": "Path 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.921 21.72a.83.83 0 0 1 1.2-.594 6.516 6.516 0 0 0 2.85.772 5.05 5.05 0 0 0 2.768-.772c.829-.4 1.067.594 1.067.594v1.76a.71.71 0 0 1-1.067.561 5.791 5.791 0 0 0-2.768-.837 7.06 7.06 0 0 0-2.85.837s-1.178.239-1.2-.561c-.022-.8 0-1.76 0-1.76z",
    className: "cls-3",
    "data-name": "Path 6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)",
    transform: "translate(-2133.68 -6140.14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M2165.384 6153.16h42.66a5.784 5.784 0 0 1 5.784 5.784v29.64c-10.368 14.063-18.128 23.866-18.128 23.866h-.595s-19.462-.147-23.864-.147a2.28 2.28 0 0 1-2.378-.985l-9.263-9.576v-42.798a5.784 5.784 0 0 1 5.784-5.784Z",
    className: "cls-1",
    "data-name": "Path 1"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    "data-name": "Mask Group 1",
    transform: "translate(25.916 13.015)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "m11.263-.404 7.155 7.37 23.789 31.08v14.857L55.27 36.772V5.551l-.993-7.691z",
    "data-name": "hvid"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)",
    transform: "translate(-2133.68 -6140.14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M2171.164 6158.22h31.091a5.784 5.784 0 0 1 5.785 5.784v22.248a3978.897 3978.897 0 0 0-15.56 20.412h-21.316a5.784 5.784 0 0 1-5.784-5.784v-36.876a5.784 5.784 0 0 1 5.784-5.784Z",
    className: "cls-1",
    "data-name": "Path 4"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    "data-name": "Mask Group 2",
    transform: "translate(31.7 18.38)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6a6a6a",
    d: "M30.368 23.195V-4.28a1.085 1.085 0 1 1 2.169 0v27.475a1.085 1.085 0 1 1-2.169 0zm-3.615 0V-4.28a1.085 1.085 0 1 1 2.169 0v27.475a1.085 1.085 0 1 1-2.169 0zm-3.615 0V-4.28a1.085 1.085 0 1 1 2.169 0v27.475a1.085 1.085 0 1 1-2.169 0zm-3.615 0V-4.28a1.085 1.085 0 1 1 2.169 0v27.475a1.085 1.085 0 1 1-2.169 0zm-3.616 0V-4.28a1.085 1.085 0 1 1 2.169 0v27.475a1.085 1.085 0 1 1-2.169 0Z",
    "data-name": "Union 1"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 2.245,
    cy: 2.245,
    r: 2.245,
    fill: "#9a9a9a",
    className: "cls-8",
    "data-name": "Ellipse 1",
    transform: "translate(29.076 16.175)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.245,
    cy: 2.245,
    r: 2.245,
    fill: "#9a9a9a",
    className: "cls-8",
    "data-name": "Ellipse 2",
    transform: "translate(57.744 66.686)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#i)",
    transform: "translate(-2133.68 -6140.14)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.064,
    cy: 17.064,
    r: 17.064,
    fill: "#b72b1c",
    "data-name": "r\\xF8d",
    transform: "translate(2135.31 6259.65)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2",
    transform: "rotate(14.98 -443.485 88.836)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.792,
    cy: 3.792,
    r: 3.792,
    fill: "#3c3c3c",
    className: "cls-10",
    "data-name": "Ellipse 4",
    transform: "translate(11.528)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.792,
    cy: 3.792,
    r: 3.792,
    fill: "#3c3c3c",
    className: "cls-10",
    "data-name": "Ellipse 7",
    transform: "translate(23.056 11.528)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.792,
    cy: 3.792,
    r: 3.792,
    fill: "#3c3c3c",
    className: "cls-10",
    "data-name": "Ellipse 5",
    transform: "translate(11.528 23.056)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.792,
    cy: 3.792,
    r: 3.792,
    fill: "#3c3c3c",
    className: "cls-10",
    "data-name": "Ellipse 6",
    transform: "translate(0 11.528)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M13.246 16.462s.786-.021.768.73c-.018.751 0 1.38 0 1.38s.248.29 1.385.29 1.322-.294 1.322-.294v-1.38s-.024-.73.649-.73h1.3s.359-.227.306-1.17a3.594 3.594 0 0 0-.306-1.4h-1.3a.67.67 0 0 1-.649-.66c-.01-.631 0-1.257 0-1.257s-.191-.253-1.322-.287c-1.131-.034-1.386.287-1.386.287v1.253s-.052.806-.768.818a12.478 12.478 0 0 1-1.26-.064 2.9 2.9 0 0 0-.092 2.355 25.84 25.84 0 0 0 1.353.129Z",
    "data-name": "Path 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "m13.696 8.239 1.561-.155 1.624.155a.455.455 0 0 1 .46.455v2.124a.455.455 0 0 1-.455.455l-1.551-.21-1.634.21a.455.455 0 0 1-.46-.455V8.694a.455.455 0 0 1 .455-.455Z",
    className: "cls-10",
    "data-name": "Path 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "m8.237 16.883-.155-1.561.155-1.624a.455.455 0 0 1 .455-.46h2.124a.455.455 0 0 1 .455.455l-.21 1.551.21 1.634a.455.455 0 0 1-.455.46H8.692a.455.455 0 0 1-.455-.455Z",
    className: "cls-10",
    "data-name": "Path 7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "m16.881 22.341-1.561.155-1.624-.155a.455.455 0 0 1-.46-.455v-2.124a.455.455 0 0 1 .455-.455l1.551.21 1.634-.21a.455.455 0 0 1 .46.455v2.124a.455.455 0 0 1-.455.455Z",
    className: "cls-10",
    "data-name": "Path 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "m22.341 13.697.155 1.561-.155 1.624a.455.455 0 0 1-.455.46h-2.124a.455.455 0 0 1-.455-.455l.21-1.551-.21-1.634a.455.455 0 0 1 .455-.46h2.124a.455.455 0 0 1 .455.455Z",
    className: "cls-10",
    "data-name": "Path 8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorL);
export default __webpack_public_path__ + "static/media/motorL.d9881b397c675cf48ac480a5d76dd80f.svg";
export { ForwardRef as ReactComponent };